import { FunctionComponent } from "react"
import PayAndBook from "../NEATT/ActionableItems/PayAndBook";


const ScheduleFollup: FunctionComponent = () => <PayAndBook />

export default ScheduleFollup;